module.exports = __webpack_public_path__ + "static/media/logo-color.f45ba7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-color.png
// module id = 224
// module chunks = 0